var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Equipo No Seriado" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("InfromacioRequerimientoForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pasoActivoIndex === _vm.pasos.requerimiento.step,
                expression: "pasoActivoIndex === pasos.requerimiento.step"
              }
            ],
            attrs: {
              modoVer: true,
              isVerDetalle: true,
              modoEditar: false,
              readonly: true,
              params: _vm.params
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }